export interface PrivilegeValidatorComponentProps {
    showButton: boolean;
    children: any;
}

export const PrivilegeValidatorComponent: React.FC<PrivilegeValidatorComponentProps> = ({
    showButton,
    children
}) => {
    return showButton && children;
}